var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-view',{attrs:{"endpoint":_vm.endpoint + 'things',"name":"Thing","permissions":"things","values":_vm.values},model:{value:(_vm.item),callback:function ($$v) {_vm.item=$$v},expression:"item"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a607d5e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"objectAssign":"Object.assign","transforms":{"stripWith":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ThingEdit.vue
// module id = null
// module chunks = 